import { render, staticRenderFns } from "./CourseMarket.vue?vue&type=template&id=4cf69acf&scoped=true&"
import script from "./CourseMarket.vue?vue&type=script&lang=js&"
export * from "./CourseMarket.vue?vue&type=script&lang=js&"
import style0 from "./CourseMarket.vue?vue&type=style&index=0&id=4cf69acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf69acf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VFadeTransition,VRow,VSheet})
